import { useState } from 'react';
import { resolveApiBaseUrl } from '../../services/runtimeConfig';

export const cleanTenantDomain = (value = '') => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/^https?:\/\//, '')
  .replace(/^www\./, '')
  .split('/')[0]
  .split('?')[0]
  .split('#')[0]
  .replace(/:\d+$/, '')
  .replace(/\.$/, '');

export const primaryTenantDomain = (tenant = {}) => {
  const fromList = (tenant.custom_domains || tenant.domains || tenant.domain_aliases || [])
    .find((domain) => domain && !String(domain).startsWith('www.'));
  return cleanTenantDomain(
    tenant.canonical_domain
    || tenant.customDomain
    || tenant.custom_domain
    || tenant.domain
    || fromList
    || '',
  );
};

export const tenantInitials = (tenant = {}) => {
  const label = tenant.tenant_name || tenant.name || tenant.tenant_slug || tenant.slug || '?';
  const initials = String(label)
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return initials || '?';
};

export const tenantLogoUrl = (tenant = {}) => {
  const url = tenant.logo_url || tenant.intro_logo_url || tenant.icon_url || tenant.branding?.logo_url || '';
  if (!url) return '';
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  const path = url.startsWith('/') ? url : `/${url}`;
  const tenantDomain = primaryTenantDomain(tenant);
  if (tenantDomain && path.startsWith('/uploads/')) {
    return `https://${tenantDomain}${path}`;
  }
  return `${resolveApiBaseUrl()}${path}`;
};

export default function TenantLogo({
  tenant,
  className = 'h-9 w-9',
  textClassName = 'text-xs',
  imageClassName = 'object-contain p-1',
}) {
  const [failed, setFailed] = useState(false);
  const logo = failed ? '' : tenantLogoUrl(tenant);
  const color = tenant?.primary_color || tenant?.branding?.primary_color || '#D4AF37';

  return (
    <div
      className={`flex ${className} shrink-0 items-center justify-center overflow-hidden rounded-lg border border-white/10 bg-[#0B0E14]`}
      title={tenant?.tenant_name || tenant?.name || 'Tenant'}
    >
      {logo ? (
        <img
          src={logo}
          alt={tenant?.tenant_name || tenant?.name || 'Tenant logo'}
          className={`h-full w-full ${imageClassName}`}
          onError={() => setFailed(true)}
        />
      ) : (
        <span className={`${textClassName} font-black`} style={{ color }}>
          {tenantInitials(tenant)}
        </span>
      )}
    </div>
  );
}
